import {IOwayoDataModel} from "./model";
import {AuswahlProdukt, Feature, Product, SelectedFeature} from "./product";
import {EventListener, EventVerteiler} from "../global/eventVerteiler";
import {ResourceInvalidationTriggers} from "../global/resourcemanager/resourceManager";
import {Produktresponse, CurrentproductPossibleDesignEntry} from "./databaseInterfaceClasses";
import {SELOBTAB_EVENTNAMES} from "../global/GlobalEventnames";
import {ProductList, ProduktListe} from "./produktListe";
import globalsObject from "./globalsObject";
import DEBUG from "./DEBUG";
import axios from "axios";
import {createProduktPHPParameters, loadproduktPhpAndRegisterResource} from "../global/produktphpConnector";
import {arrayElementByKeyValue} from "../global/arrayHelper";
import {logIfDebug} from "../global/logFunctions";
import {ProduktAuswahlProdukt} from "../../konfi_mobile/src/store/ProduktAuswahlStore";
export interface Productstage {
    stageNewProduct(auswahlProdukt:AuswahlProdukt|ProduktAuswahlProdukt, features:SelectedFeature[], data: Produktresponse):void;
    getproduct():Product
    getModel():string;
    setBaseModel(model:string|null):void;
    getPossibleDesigns():Array<CurrentproductPossibleDesignEntry>;
    useStagedProductAsCurrentProduct():void;
    getRealSport():string;
}



export const loadProductPreviewPicture = (produkt:Product)=>{
    const path = encodeURIComponent(["", "modelle", produkt.cut, produkt.model, "Konfi-Voransichten", ""].join("/"));
    return axios("/konfigurator_php/auswahlmodul/getproductPreviewPicture.php?path="+path+"&design="+produkt.basisdesign+"&raw=1");
}



export class ProductController extends EventListener{
    produkte:ProductList;
    public model: IOwayoDataModel;
    public readonly productStage: Productstage;
    public static getNewProductList: (sport:string) => ProductList;

    constructor(model: IOwayoDataModel, productStage:Productstage, productList:ProductList, getNewProductList:(sport:string)=>ProductList) {
        super();

        this.model = model;
        this.productStage = productStage;
        this.produkte = productList;
        ProductController.getNewProductList = getNewProductList;
        this.produkte.setController(this);


        this.addEventListener("produktLoadedCallback", (data) => this.produktLoadedCallback(data.realsport, data.derived_sport))
    }



    public isPatternErlaubt() {
        const prod = this.getAuswahlProduktByAuwiProdukt();
        if (prod === null) {
            return false;
        }
        logIfDebug("erlaubt:" + !!prod.ImKonfiKoennenPatternsVerwendetWerden);
        return !!prod.ImKonfiKoennenPatternsVerwendetWerden;
    }

    public auswahlProdukteLoaded = ()=>{
        EventVerteiler.broadcast("initProduktAuswahlEvent", {produkte: this.produkte.getAuswahlProdukte()});
        globalsObject.resourceManager.registerLoadedResourceWithoutData("initProduktAuswahl", "initLoadProducte");
    }


    private getAuswahlProdukt = (produktName: string) => arrayElementByKeyValue(this.produkte.getAuswahlProdukte(), "Produkt", produktName);
    private getAuswahlProduktByAuwiProdukt = () => arrayElementByKeyValue(
        this.produkte.getAuswahlProdukte(),
        "AuwiProdukt",
        this.model.getCurrentOwayoProduct().produkt
    )

    public generateOwayoProduct(produkt: string, features):Promise<Produktresponse> {
        return new Promise<Produktresponse>((resolve, reject) => {
            const selProduct = this.getAuswahlProdukt(produkt);

            if (DEBUG) {
                console.log(features);
            }

            //globalsObject.resourceManager.executeInvalidation(ResourceInvalidationTriggers.PRODUCTCHANGE);
            this.callProduktPHP(selProduct, features).then(data=>resolve(data)).catch(
                () => {
                    globalsObject.errorHandler.handleErrorTranslateMessage("ajaxFail", "generateOwayoProduct", "konf_error_generatingProduct")
                    reject()
                });
        })

    }

    private callProduktPHP(selProduct: AuswahlProdukt, features, toStage=false):Promise<Produktresponse> {
        return new Promise<Produktresponse>((resolve, reject) => {
            const suffix = toStage ? ".stage" : ""
            EventVerteiler.broadcast("blockComponentByIDEvent", {id:"open-popup-produktauswahl-features"})
            const data = createProduktPHPParameters(
                selProduct,
                features,
                this.model.getWebsportFuerProduktAuswahlNormalized(),
                this.model.getLanguageIso(),
                this.model.isOwayoDirectLogin()
            );
            loadproduktPhpAndRegisterResource(data, suffix).then(response=>{
                this.processProduktPHPData(selProduct, features, response)
                resolve(response)
            }).catch(reject);
        })
    }

    private processProduktPHPData(selProduct, features, data: Produktresponse) {
        if (data.Produkt === null) {
            globalsObject.errorHandler.handleErrorTranslateMessage("featureNotPossible", "generateOwayoProduct", "konf_error_featureCombinationNotPossible");
            this.productStage.setBaseModel(null);
            return;
        }
        this.productStage.stageNewProduct(selProduct, features, data);
        EventVerteiler.broadcast("unblockComponentByIDEvent", {id:"open-popup-produktauswahl-features"})
    }

    public loadOwayoProduct(productCategory: string) {
        const stagedproduktPhp = EventVerteiler.resourceManager.getResourceByName("produkt.php.stage");
        // EventVerteiler.resourceManager.executeInvalidation(ResourceInvalidationTriggers.PRODUCTCHANGE);
        if(stagedproduktPhp !== null) {
            EventVerteiler.resourceManager.executeInvalidation(ResourceInvalidationTriggers.PRODUCTCHANGE);
            EventVerteiler.resourceManager.deleteResourceByName("produkt.php");
            EventVerteiler.resourceManager.registerResource({
                resourceName:"produkt.php",
                invalidatedWhen:ResourceInvalidationTriggers.PRODUCTCHANGE,
                data:stagedproduktPhp.data,
                startingStati:["loaded"]}
            );
        }
        EventVerteiler.resourceManager.deleteResourceByName("produkt.php.stage");



        globalsObject.controller.extractInformationFromEntwurfForProductChange();
        this.productStage.useStagedProductAsCurrentProduct();
        EventVerteiler.broadcast("ProductChangedEvent");
        const possibleDesigns = this.model.getCurrentOwayoProduct().possibleDesigns;
        const designInTransferStorage = globalsObject.controller.getEntwurfTransferStorage().design;
        const design = this.getDesignFromPossibleDesignsOrBasisDesign(possibleDesigns, designInTransferStorage);
        logIfDebug(productCategory);
        globalsObject.controller.initNewEntwurf(productCategory, design, this.model.getCurrentOwayoProduct().model);

        EventVerteiler.broadcast("updateTitelTagEvent", {
            product: this.model.getCurrentOwayoProduct(),
            design: design,
            vorbelegungAmount: this.model.getCurrentOwayoProduct().VorbelegungPreisanzeige
        });

        EventVerteiler.broadcast('DreiDPartsnachBedarfEinUndAusblendenEvent', {features: this.model.getCurrentOwayoProduct().selectedFeatures});
        const eventName = this.model.getCurrentOwayoProduct().VorgegebenerArtikel !== "" ? SELOBTAB_EVENTNAMES.ACTIVATE_ARTIKEL_VIEW : SELOBTAB_EVENTNAMES.ACTIVATE_PRODUCT_VIEW;
        EventVerteiler.broadcast(eventName);
    }

    private static designAvailableAndNotDiscarded(design, possibleDesigns: { Design: string }[]) {
        const d = arrayElementByKeyValue(possibleDesigns, "Design", design);
        return d !== null  && parseInt(d.KonfiDiscarded) !== 1;
    }

    private getDesignFromPossibleDesignsOrBasisDesign(possibleDesigns: { Design: string }[], designInTransferStorage: string) {
        return ProductController.designAvailableAndNotDiscarded(designInTransferStorage, possibleDesigns) ?
            designInTransferStorage :
            (this.model.getCurrentOwayoProduct() as Product).basisdesign;
    }

    private produktLoadedCallback(realsport, derived_sport) {
        if (this.productStage.getproduct() === null || this.productStage.getRealSport() !== realsport) {
            this.produkte = ProductController.getNewProductList(derived_sport);
            this.produkte.setController(this);
            this.produkte.loadProdukte();
        }
    }
}
